/*
 * File: /src/router/routes/leadSourceDetails.js
 * Created Date: Friday March 28th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 28th March 2025 4:31:36 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */

const ListSourceDetails = () =>
  import(
    /* webpackChunkName: "LeadSourceDetails" */ 'src/components/Dashboard/Views/LeadSources/LeadSourceDetailList.vue'
  );

const EditSourceDetails = () =>
  import(
    /* webpackChunkName: "LeadSourceDetails" */ 'src/components/Dashboard/Views/LeadSources/LeadSourceDetailEdit.vue'
  );

export const leadSourceDetailRoutes = [
  {
    path: 'lead-source-details/',
    name: 'Lead Sources Details',
    component: ListSourceDetails,
  },
  {
    path: 'lead-source-details/add',
    name: 'Add New Lead Source Details',
    component: EditSourceDetails,
  },
  {
    path: 'lead-source-details/edit/:id',
    name: 'Edit Lead Source Details',
    component: EditSourceDetails,
  },
];
